module.exports = __webpack_public_path__ + "static/media/login-logo.7bfc694c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-logo.png
// module id = 1138
// module chunks = 0